export default __webpack_public_path__ + "static/media/report.711c39e4.png";